import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Layout from "../components/common/Layout";
import axios from "axios";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import checkTime from "../components/constants/CheckTime"
import { addAuditLog } from "../components/AuditLog"
import { format } from "date-fns"

const Home = props => {
  const userId =
  JSON.parse(localStorage.getItem("user")) === null
    ? null
    : JSON.parse(localStorage.getItem("user"))[0].Id;
  const handleSort = (column, sortDirection) => {
      setSortedColumn(column.selector);
      setSortDirection(sortDirection);
    };
  const selectDayRangeDdl = [
      { value: 7, label: "7 days"},
      { value: 15, label: "15 days"},
      { value: 30, label: "30 days"},
      { value: 60, label: "60 days"},
      { value: 90, label: "90 days"},
      { value: 120, label: "120 days"},
      { value: 150, label: "150 days"}
    ];
  const [dayPlus, setDayPlus] = useState(30);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);    
  const [loading, setLoading] = useState(false);

  const exportExcel = () => {
    //add Audit Log
    addAuditLog({ menu: "Home" , event: "Export Duedate", createBy: userId });


    const result = [];
    result.push(columns.filter( c => columnsCheckFormData[c.selector]).map( x => x.selector));

    /* Sort ID by the same DataTable */

     let filteredArray = data.filter(data => parseInt(data.countDate) <= dayPlus).slice();
     //console.log(sortDirection);
     //console.log(sortedColumn);
     filteredArray.sort((a,b) => 
     {
      const aField = a[sortedColumn] 
      const bField = b[sortedColumn]

      let comparison = 0;
      
      if (aField > bField) {
       comparison = 1;
      } else if (aField < bField) {
       comparison = -1;
      }
    
      return sortDirection === 'desc' ? comparison * -1 : comparison;
    })
      
     //console.log(`${filteredArray.map(x => x.CaseId)}`);
     //console.log(`${result}`);


    /* Prepared */
    setLoading(true);

    axios.post(process.env.REACT_APP_EXL_URL + "/File/GetCaseHomeExcelById",
      {
        CaseId : `${filteredArray.map(x => x.CaseId)}`,
        Cols: `${result}`,
        Key: 'xGhJjuMTLWfhq6Td8Q4RlAgdwdtwf4ch',
        SortBy: `${sortedColumn}`,
        Sort: `${sortDirection}`,
        Day: `${dayPlus}`,
        },
        { responseType: 'blob' }

    ).then(response => {
      let link = document.createElement('a');
      let day = new Date();

      link.href = window.URL.createObjectURL(new Blob([response.data], 
        {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
      link.download = day.toISOString().slice(0,10) + "-Home_export.xlsx";
      link.click();
    }).catch(error => {
        console.log(error);
    }).finally(() => {
      setLoading(false);
    });

  }

  const [data, setData] = useState([]);
  const customSort = (rows, selector, direction) => {
    return rows.sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparitors
      const aField = typeof selector === 'function' ? selector(rowA) : rowA[selector];
      const bField = typeof selector === 'function' ? selector(rowB) : rowB[selector];

    
      let comparison = 0;
    
      if (aField > bField) {
       comparison = 1;
      } else if (aField < bField) {
       comparison = -1;
      }
      //console.log(aField + " : " + bField + " : " + (direction === 'desc' ? comparison * -1 : comparison));

      return direction === 'desc' ? comparison * -1 : comparison;
     });
   };
  const columns = [
    {
      cell: row => (
        <Link to={"/cases/view/" + row.CaseId} target="_blank">
          <button className="btn btn-sm btn-primary">
            <i className="fa fa-eye"></i> View
          </button>
        </Link>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: "125px",
      show: 1,
      button: true
    },
    {
      cell: row => {
        if ( parseInt(row.countDate) < 0) {
          return <p style={{ color: "red" }}>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        } else if(parseInt(row.countDate) === 0){
          return <p style={{ color: "#ff7600" }}>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        } else if(parseInt(row.countDate) > 7){
          return <p>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        } else {
          return <p style={{ color: "rgb(34, 107, 150)" }}>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        }
      },
      name: "Deadline",
      selector: "DueDate",
      sortable: true,
      wrap: true
    },
    {
      name: "Event Text",
      selector: "EventsName",
      sortable: true,
      wrap: true
    },
    {
      cell: row => (
        <img 
          height = "auto" 
          width="100px" 
          style={{ padding: "0px 5px", objectFit: "contain", maxHeight: "100px" }}
          alt="IMG"
          src = {
            row.FilePath === null ?
            "/images/logo/no-img.png"
            : "/images/uploads" + row.FilePath
          } />
      ),
      name: "Image",
      selector: "Image",
      sortable: true,
      wrap: true
    },
    {
      name: "Instructor",
      selector: "Instructor",
      sortable: true,

      wrap: true
    },
    {
      name: "Instructor Code",
      selector: "InstructorCode",
      sortable: true,

      wrap: true
    },
    {
      name: "Matter",
      selector: "Matter",
      sortable: true,

      wrap: true
    },
    
    {
      name: "IRN",
      selector: "CaseReference",
      sortable: true,

      wrap: true
    },
    {
      name: "Owner",
      selector: "Owner",
      sortable: true,

      wrap: true
    },
    {
      name: "Owner Code",
      selector: "OwnerCode",
      sortable: true,

      wrap: true
    },
    {
      name: "App No.",
      selector: "AppNo",
      sortable: true,

      wrap: true
    },
    {
      name: "Filing Date",
      selector: "CreateDateTime",
      sortable: true,

      wrap: true,
      cell: row => (
        <div>
          {row.CreateDateTime ? format(new Date(row.CreateDateTime), 'dd-MMM-yyyy') : ''}
        </div>)
    },
    {
      name: "Class",
      selector: "ClassList",

      center: true,
      sortable: true,
      wrap: true
    }
  ];
  const [showManageColumns, setShowManageColumns] = useState(false);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState({
    "DueDate": 1,
    "EventsName": 1,
    "Matter": 1,
    "Image": 1,
    "Instructor": 1,
    "InstructorCode": 1,
    "CaseReference": 1,
    "Owner": 1,
    "OwnerCode": 0,
    "AppNo": 1,
    "CreateDateTime": 0,
    "ClassList": 1
  });

  useEffect(() => {
    if (sortedColumn && sortDirection) {
      console.log(`DataTable is sorted by column: ${sortedColumn} in ${sortDirection} order.`);
    }
  }, [sortedColumn, sortDirection]);

  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/dashboard")
      .then(res => {
        setData(res.data);
      });
    //eslint-disable-next-line
  }, []);
  const checkInputManageColumn = (name) => 
  (<div key={name} className="col-sm-12">
      <input 
        type="checkbox" 
        className="checkboxCustom1"
        id={name}
        name={name} 
        defaultChecked={columnsCheckFormData[name]} 
        onChange={ e => setcolumnsCheckFormdata({ 
          ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
        })} /> 
        <label htmlFor={name}>
          {columns.filter( c => c.selector === name)[0].name}
        </label>
    </div>)

  return (
    <Layout activeLinkTo="/home" menuId="1">
      <div className="table-responsive" style={{padding:"10px 0"}} >
        <div className="container-fluid">
          <div className="card border-secondary">
            <h5 className="card-header text-white bg-primary"> Deadline List</h5>
            <div className="col-lg-3" style={{position:"absolute", right:"0px", padding:"5px"}}>
              <Select 
                onChange={ e => setDayPlus(parseInt(e.value))}
                defaultValue={{ value: 30, label: "30 days"}}
                options={selectDayRangeDdl}
              />
            </div>
            <div className="card-body" style={{paddingBottom:"32px"}}>
                <div className="table-responsive">
                  <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                    <i className="fa fa-cog"></i> Manage Columns
                  </button>
                  <button type="button" className="btn btn-primary mr-2" 
                    style={{position:"absolute", right:0}} 
                    onClick={() => {
                          exportExcel()
                        }
                    } >
                    <i className="fa fa-external-link"></i> Export file
                  </button>
                  <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                    <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                  </a>
                  <DataTable       
      

                    noHeader={true}
                    pagination={true} 
                    onSort={handleSort}
                    sortFunction={customSort} 
                    paginationPerPage={50}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    columns={columns.filter(c => columnsCheckFormData[c.selector] || (c.show ))}
                    data={data.filter(data => parseInt(data.countDate) <= dayPlus)}  
                    />
                  <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                    <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                  </a>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Manage Columns*/}
      <Modal
        size="sm"
        dialogClassName="columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {Object.keys(columnsCheckFormData).map( (e) => checkInputManageColumn(e))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    {/* Modal Manage columns*/}



      {/* Modal Loading */}

   
      <Modal
          size="sm"
          dialogClassName="main-modal"
          show={loading}

          onHide={() => {
            setLoading(false);
          }}
          centered
        >
          
          <Modal.Body>
            <div className="text-center mt-2">
              <h1>
          <i className="fa fa-hourglass" /> </h1> <br/> Now processing a report, please wait a minute.
          
          </div>
          </Modal.Body>
        </Modal>
  
      {/* Modal Loading */}


    
    </Layout>
  );
};

export default Home;
